<template>
  <div v-if="hasDiscounts" class="rounded-md text-sm">
    <div v-if="subsequentPrice && subscriptionDiscounts.subsequent">
      <span
        v-dompurify-html="
          $t(
            hasInitialDiscount
              ? 'subscription.discount_info_all'
              : 'subscription.discount_info',
            {
              discount:
                subscriptionDiscounts.subsequent.value +
                subscriptionDiscounts.subsequent.unit,
              price: toCurrency(subsequentPrice * quantity),
            },
          )
        "
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue'

type Props = {
  quantity?: number
  hasInitialDiscount?: boolean
  subsequentPrice?: number
  subscriptionDiscounts: {
    subsequent: SubscriptionDiscount | undefined
    initial: SubscriptionDiscount | undefined
  }
}

const props = withDefaults(defineProps<Props>(), {
  quantity: 1,
  hasInitialDiscount: false,
  subsequentPrice: undefined,
  subscriptionDiscounts: undefined,
})

const quantity = toRef(props, 'quantity')
const subscriptionDiscounts = toRef(props, 'subscriptionDiscounts')

const hasDiscounts = computed(
  () =>
    !!subscriptionDiscounts.value?.initial ||
    !!subscriptionDiscounts.value?.subsequent,
)
</script>
